const parseAmount = (value) => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const sumLineTotals = (items = []) =>
  items.reduce((sum, item) => sum + parseAmount(item?.line_total), 0);

export const filterItemsByBrand = (items = [], { brandId = null, brandName = null } = {}) => {
  if (!brandId && !brandName) return items;

  return items.filter((item) => {
    if (brandId) {
      const itemBrandId = item.brand_id ?? item.brand?.id;
      return itemBrandId != null && String(itemBrandId) === String(brandId);
    }
    if (brandName) {
      return item.brand?.name === brandName;
    }
    return true;
  });
};

/**
 * Seller-scoped totals for reports. Uses line_total sums only — not full cart subtotal/grand_total.
 */
export const getSellerOrderTotals = (order, { brandId = null, brandName = null } = {}) => {
  const sellerItems = filterItemsByBrand(order?.order_items || [], { brandId, brandName });
  const sellerSubtotal = sumLineTotals(sellerItems);

  return {
    sellerItems,
    sellerSubtotal,
    hasMultipleSellersInCart: (order?.order_items || []).length > sellerItems.length,
  };
};
